/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * List of files; can be multiple
 */
export interface Body {
  files: Array<Blob>;
  bucket: string;
  type: Body.TypeEnum;
}
// tslint:disable-next-line:no-namespace
export namespace Body {
  export type TypeEnum = 'image' | 'file';
  export const TypeEnum = {
      Image: 'image' as TypeEnum,
      File: 'file' as TypeEnum,
  };
}
